import React, { Component } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import moment from "moment";

import { Link } from "react-router-dom";
import "./email.css";
import SafeHTML from "components/buttons/SafeHTML";

import PropTypes from "prop-types";
import ComposeMailReply from "./ComposeEmailReply";
import ComposeMailForword from "./ComposeEmailForword";
import { toast } from "react-toastify";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import Swal from "sweetalert2";

class EmailActivityList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedEmailId: null,
      dropdownOpen: null,
      loading: true,
      showReply: false,
      showForward: false,
      inboxMails: props.inboxMails || [],
      selectedEmails: [],
      replyEmail: null,
    };
  }

  componentDidMount() {
    // Simulate loading delay
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1200);
  }

  toggleExpand = (id) => {
    this.setState({
      expandedEmailId: this.state.expandedEmailId === id ? null : id,
    });
  };

  toggleDropdown = (id) => {
    this.setState({
      dropdownOpen: this.state.dropdownOpen === id ? null : id,
    });
  };

  renderSkeleton() {
    return (
      <Card className="email-card mb-3">
        <CardBody>
          <div className="skeleton skeleton-title"></div>
          <div className="skeleton skeleton-line mt-3"></div>
          <div className="skeleton skeleton-line"></div>
          <div className="skeleton skeleton-line"></div>
        </CardBody>
      </Card>
    );
  }

  // ======================================================
  //                DELETE EMAIL FUNCTION
  // ======================================================
  handleDelete = async (selectedEmails) => {
    if (selectedEmails.length === 0) {
      Swal.fire({
        title: "No emails selected",
        text: "Please select emails to delete.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    });

    if (!result.isConfirmed) return;

    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const deleteRequests = selectedEmails.map((emailId) => {
        const url = `${API_URL}Gmail/DeleteGoogleEmail/${this.props.agentData?.agentId}/${emailId}/1`;
        return axios.get(url, { headers });
      });

      await Promise.all(deleteRequests);

      // REMOVE EMAILS FROM LOCAL STATE
      this.setState((prevState) => ({
        inboxMails: prevState.inboxMails.filter(
          (mail) => !selectedEmails.includes(mail.emailDetailId)
        ),
        selectedEmails: [],
      }));

      Swal.fire({
        title: "Deleted!",
        text: "Selected emails have been removed.",
        icon: "success",
      });
    } catch (error) {
      console.error("Error deleting emails", error);
      Swal.fire({
        title: "Error!",
        text: "An error occurred while deleting emails.",
        icon: "error",
      });
    }
  };

  // ======================================================

  render() {
    const { lead, agentData, inboxMails } = this.props;
    const { expandedEmailId, dropdownOpen, loading, showReply, showForward } =
      this.state;

    if (loading) {
      return (
        <>
          {this.renderSkeleton()}
          {this.renderSkeleton()}
          {this.renderSkeleton()}
        </>
      );
    }

    return (
      <>
        <div>
          {inboxMails?.map((inbox, key) => {
            const createdOnDate = moment(inbox.createdOn);
            const isToday = createdOnDate.isSame(moment(), "day");
            const isExpanded = expandedEmailId === inbox.emailDetailId;

            return (
              <Card key={key} className="email-card mb-3">
                <CardBody style={{ padding: 10 }}>
                  {/* HEADER */}
                  <Row
                    className="email-header"
                    onClick={() => this.toggleExpand(inbox.emailDetailId)}
                  >
                    <Col md="10">
                      <div className="email-title">
                        <i
                          className={`me-2 bi ${
                            isExpanded ? "bx bx-caret-up" : "bx bx-caret-down"
                          }`}
                        ></i>

                        <span className="email-subject">
                          {inbox.subject ? (
                            <SafeHTML html={inbox.subject} />
                          ) : (
                            "No subject"
                          )}
                        </span>
                        &nbsp; from <strong className="ms-2">{inbox.to}</strong>
                      </div>
                    </Col>

                    <Col md="2" className="text-end email-date">
                      {isToday
                        ? createdOnDate.format("h:mm A")
                        : createdOnDate.format("MMM DD")}
                    </Col>
                  </Row>

                  {/* COLLAPSIBLE BODY */}
                  {isExpanded && (
                    <div className="email-body">
                      {/* Sender Block */}
                      <Row className="align-items-center mb-3">
                        <Col md="1">
                          <div className="avatar-circle">
                            {inbox.from ? inbox.from[0].toUpperCase() : "U"}
                          </div>
                        </Col>

                        <Col md="7">
                          <div className="sender-name">
                            <strong>{inbox.to}</strong>
                          </div>
                          <div className="sender-to"> to {inbox.from}</div>
                        </Col>

                        <Col md="4" className="text-end">
                          <Dropdown
                            isOpen={dropdownOpen === inbox.emailDetailId}
                            toggle={() => this.toggleDropdown(inbox.emailDetailId)}
                          >
                            <DropdownMenu>
                              {inbox.associations?.length > 0 ? (
                                inbox.associations.map((a, i) => (
                                  <DropdownItem key={i}>{a}</DropdownItem>
                                ))
                              ) : (
                                <DropdownItem>No associations</DropdownItem>
                              )}
                            </DropdownMenu>
                          </Dropdown>
                        </Col>
                      </Row>

                      {/* Email Content */}
                      <div className="email-content-box">
                        {inbox.message ? (
                          <SafeHTML html={inbox.message} />
                        ) : (
                          <p className="text-muted">No message content</p>
                        )}
                      </div>

                      {/* Action Buttons */}
                      <div className="email-actions">
                        <Link
                          to="#"
                          onClick={() =>
                            this.setState({
                              showReply: true,
                              replyEmail: inbox,
                            })
                          }
                        >
                          <Button color="primary" size="sm" className="me-2">
                            Reply
                          </Button>
                        </Link>

                        <Link
                          to="#"
                          onClick={() =>
                            this.setState({
                              showForward: true,
                              replyEmail: inbox,
                            })
                          }
                        >
                          <Button color="secondary" size="sm" className="me-2">
                            Forward
                          </Button>
                        </Link>

                        {/* DELETE BUTTON FIXED HERE */}
                        <Link
                          to="#"
                          onClick={() =>
                            this.handleDelete([inbox.emailDetailId])
                          }
                        >
                          <Button color="danger" size="sm">
                            Delete
                          </Button>
                        </Link>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            );
          })}
        </div>

        {showReply && (
          <ComposeMailReply
            agentData={agentData}
            toEmail={lead?.email}
            originalEmail={this.state.replyEmail}
            onClose={() => this.setState({ showReply: false })}
          />
        )}

        {showForward && (
          <ComposeMailForword
            agentData={agentData}
            toEmail={lead?.email}
            originalEmail={this.state.replyEmail}
            onClose={() => this.setState({ showForward: false })}
          />
        )}
      </>
    );
  }
}

EmailActivityList.propTypes = {
  inboxMails: PropTypes.array,
  lead: PropTypes.object,
  agentData: PropTypes.object,
};

export default EmailActivityList;
